import { Divider, Tooltip, Typography } from '@mui/material';
import { CloseRounded } from '@mui/icons-material';
import { DataGridFloatingActionToolbar, TextButton } from '@retail/components';
import { IconButton } from '@retail/products/components';
import { useCampaignTFunction } from '@retail/campaign/i18n';

interface Props {
  totalItemsCount: number;
  checkedItemsCount: number;
  onEditItems: () => void;
  onUncheckItems: () => void;
  onRemoveItems: () => void;
}

export function CampaignItemsActionToolbar({
  totalItemsCount,
  checkedItemsCount,
  onEditItems,
  onUncheckItems,
  onRemoveItems,
}: Props) {
  const t = useCampaignTFunction();

  return (
    <DataGridFloatingActionToolbar sx={{ bottom: ({ spacing }) => spacing(2) }}>
      <Tooltip title={t('campaign.columns.selection.uncheckAll')}>
        <IconButton
          sx={{ p: 0, ':hover': { color: 'common.black' } }}
          onClick={onUncheckItems}
          aria-label={t('campaign.columns.selection.uncheckAll')}
        >
          <CloseRounded fontSize="small" />
        </IconButton>
      </Tooltip>
      <Divider orientation="vertical" sx={{ height: 'auto' }} />

      <Typography variant="subtitle2" whiteSpace="nowrap">
        {t('campaign.columns.selection.selectionCount', {
          count: checkedItemsCount,
          totalCount: totalItemsCount,
        })}
      </Typography>

      <Divider orientation="vertical" sx={{ height: 'auto' }} />
      <TextButton sx={{ ':hover': { color: 'common.black' } }} onClick={onEditItems}>
        {t('campaign.columns.selection.edit')}
      </TextButton>

      <Divider orientation="vertical" sx={{ height: 'auto' }} />

      <TextButton onClick={onRemoveItems} sx={{ ':hover': { color: 'common.black' } }}>
        {t('campaign.columns.selection.remove.label')}
      </TextButton>
    </DataGridFloatingActionToolbar>
  );
}
